export const branches = {
  AIR_FORCE: "Air Force",
  ARMY: "Army",
  COAST_GUARD: "Coast Guard",
  MARINE_CORPS: "Marine Corps",
  NAVY: "Navy",
  SPACE_FORCE: "Space Force",
};

export const sparseIndexTrue = "x";
